import memoize from "memoize-one"

const DEFAULT_COLOURS = ["#2178b5", "#ff8010", "#2ea12e", "#cf0707"]

const makeAxisLabel = (series) => {
  const indexedSeries = series.map((s, idx) => ({
    ...s,
    index: idx, // add an index to stabilize the sort
  }))

  indexedSeries.sort((a, b) => {
    const aUnits = a.units || "",
      bUnits = b.units || ""
    let diff = aUnits.localeCompare(bUnits)
    if (diff !== 0) return diff

    diff = a.tag.localeCompare(b.tag)
    if (diff !== 0) return diff

    return a.index - b.index
  })

  const tagGroups = []
  let currentUnits = null,
    currentTags = []

  function flush() {
    if (currentTags.length > 0) {
      tagGroups.push(`${currentTags.join(",")} [${currentUnits}]`)
    }
    currentTags = []
  }

  for (const s of indexedSeries) {
    if (s.units !== currentUnits) {
      flush()
      currentUnits = s.units
    }

    if (currentTags.length === 0 || s.tag !== currentTags[currentTags.length - 1]) {
      currentTags.push(s.tag)
    }
  }
  flush()

  return tagGroups.join("; ")
}

export const getSeriesConfigs = memoize(function (observations) {
  const series = []

  const xSeries = [],
    ySeries = []

  for (let i = 0; i < observations.length - 1; i += 2) {
    series.push({
      label: `${observations[i].tag} vs ${observations[i + 1].tag}`,
      style: "points",
      pointSize: 2,
      colour: DEFAULT_COLOURS[(i / 2) % DEFAULT_COLOURS.length],
      colourByTime: observations.length === 2,
    })

    xSeries.push(observations[i])
    ySeries.push(observations[i + 1])
  }

  return {
    seriesConfigs: series,
    xAxisLabel: makeAxisLabel(xSeries),
    yAxisLabel: makeAxisLabel(ySeries),
  }
})
